import * as formRules from './marketo-redirect-rules.json';

let marketTranslationKey = (window).marketTranslationKey ||  'EN';

export class MarketoFormRules {

    static exists(id) {
        try {
            if (formRules) {
                if ((id in formRules)) {
                    return true;
                }
            }
        } catch (err) {
            console.log(err);
            return false;
        }

        return false;
    }

    static run(id, leadValues = false) {

        try {
            var link = false;

            // If submitted form ID is in the rules
            if ( id in formRules ) {

                let allFormRules = (formRules)[id][marketTranslationKey].rules;

                allFormRules.forEach(formRule => {

                    // Variable to increment to set the match
                    let match_form_fields = 0;

                    // Only if the link is not set
                    if (link === false) {
                        // We go through all the specific rules
                        formRule.rule.forEach(rule => {

                            let ruleField = 0;
                            let ruleValue = '';
                            let ruleCompare = '=';
                            let ruleType = 'STRING';

                            // Form Field Check
                            if ( rule.field ) {
                                // Remove the hash
                                ruleField = rule.field.replace('#', '');
                                // If the field submitted has a value
                                if (leadValues.form[ruleField]) {
                                    // Remove spaces and split
                                    ruleValue = rule.value.replace(/,\s/g, ',').split(',');
                                    // Increment if there is a match
                                    (match_form_fields) += (ruleValue).indexOf(leadValues.form[ruleField]) !== -1;
                                }
                            }
                            
                            // Marketo Field Check
                            if ( rule.field_marketo ) {

                                ruleField = rule.field_marketo;
                                let leadFieldValue = leadValues.marketo[ruleField] !== undefined ? leadValues.marketo[ruleField] : '';

                                ruleValue = rule.value;

                                // Marketo returns null when a checkbox is not toggled so we convert it to empty string for comparing below
                                if ( leadFieldValue == null ) {
                                    leadFieldValue = '';
                                }

                                if ( rule.compare ) {
                                    ruleCompare = rule.compare;
                                }
                                if ( rule.type ) {
                                    ruleType = rule.type;
                                }

                                let ruleMatch = false;

                                if ( ruleType == 'DATE' ) {
                                    ruleMatch = MarketoFormRules.checkFieldDate(ruleField, ruleValue, ruleCompare, leadFieldValue );
                                } else if ( ruleType == 'BOOLEAN' ) {
                                    ruleMatch = MarketoFormRules.checkFieldBoolean(ruleField, ruleValue, ruleCompare, leadFieldValue)
                                }

                                if ( ruleMatch ) {
                                    match_form_fields++;
                                }

                            }
                            
                        });

                        // All rules in AND group passed
                        if (formRule.type === 'and' && match_form_fields === formRule.rule.length) {
                                link = formRule.link;
                            // One or more rule in OR group passed
                        } else if (formRule.type === 'or' && match_form_fields) {
                            link = formRule.link;
                        }
                    }
                });

                return link ? link : (formRules)[id][marketTranslationKey].link;

            }
        } catch (err) {
            console.log(err);
        }
    }


    static checkFieldBoolean(ruleField, ruleValue, ruleCompare, leadFieldValue ) {       
        if ( ruleValue.toLowerCase() == String(leadFieldValue).toLowerCase() ) {
            return true;
        }
        return false;  
    }

    static checkFieldDate(ruleField, ruleValue, ruleCompare, leadFieldValue ) {

        if ( leadFieldValue == '' && ruleValue == '') {
            return true;
        }

        if ( leadFieldValue ) {
            let marketoDateRegex = /(\d+-\d+-\d+)T(\d+:\d+:\d+)Z/i; // TODO
            let marketoDateMatch = leadFieldValue.match(marketoDateRegex);

            // Check if lead has a valid date
            if (marketoDateMatch[0]) {

                // Check if rule is a calculation with "now"
                if ( ruleValue.includes('now') ) {
                    let ruleDateRegex = /(now)\s?(\+|-)\s?(\d+)/i;
                    let ruleDateMatch = ruleValue.match(ruleDateRegex);
            
                    if ( ruleDateMatch ) {
            
                        if ( ruleDateMatch[1] && (ruleDateMatch[2] == '+' || ruleDateMatch[2] == '-' ) && ruleDateMatch[3] ) {
                            // let dateNow = new Date();
                            let mktoTimeNow = new Date();
                            mktoTimeNow.setHours( mktoTimeNow.getHours() + 2 );

                            let leadTrialDequestDate = new Date(Date.parse(leadFieldValue));
                            let ruleCompareValue = mktoTimeNow

                            if ( ruleDateMatch[2] == '-' ) {
                                ruleCompareValue.setDate(ruleCompareValue.getDate() - parseInt(ruleDateMatch[3]));
                            } else if ( ruleDateMatch[2] == '+' ) {
                                ruleCompareValue.setDate(ruleCompareValue.getDate() + parseInt(ruleDateMatch[3]));
                            }

                            switch (ruleCompare) {
                                case '<':
                                    return leadTrialDequestDate < ruleCompareValue
                                case '>':
                                    return leadTrialDequestDate > ruleCompareValue
                                case '==':
                                    return leadTrialDequestDate == ruleCompareValue
                                case '!=':
                                    return leadTrialDequestDate != ruleCompareValue
                                default:
                                    return leadTrialDequestDate == ruleCompareValue
                            }

                        }
                    }

                }

            }
        }

        return false;

    }
}